import { Heading, Box, AbsoluteCenter, Image, Text, Button, VStack, HStack } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import logo from './YAVD-icon-256.ico'


function App() {
  const base_url = 'https://yavd-back.yavd.workers.dev'
  const [latest_version, set_latest_version] = useState('v')

  useEffect(() => {
    console.log('useEffect')
    fetch(`${base_url}/latest`)
    .then((response) => response.text())
    .then((text) => {
      console.log(text)
      set_latest_version(text)
    })
    .catch((err) => {
      console.log(err)
    })
  })

  const download = (os) => (event) => {
    const url = `${base_url}/download/${os}/${latest_version}`
    window.open(url, '_blank')
  }

  return (
    <Box position='relative' h='90%'>
      <AbsoluteCenter axis='both'>
    <VStack spacing={4} align='center' justify='center'>
      <Heading as='h1' size='4xl'>YAVD</Heading>
      <Image src={logo} boxSize='80px' />
      <Text p='2em'>Video Downloader</Text>
      <HStack spacing={2}>
        <Button colorScheme='green' onClick={download('mac')}>Download for MacOS</Button>
        <Button colorScheme='green' onClick={download('windows')}>Download for Windows</Button>
      </HStack>
      <Text p='1em' fontSize='xs'>Version {latest_version}</Text>
    </VStack>
    </AbsoluteCenter>
    </Box>
  );
}

export default App;
